import { type FC } from 'react';
import { NoDataMessage } from '@/components/NoDataCard/NoDataCard';
import styles from './RecentSessionsPanel.module.scss';

interface RecentSessionsPanelProps {
  onViewAllSessions: () => void;
}

const RecentSessionsPanel: FC<RecentSessionsPanelProps> = ({ onViewAllSessions }) => {
  return (
    <div
      className={styles.panel}
      data-test-component="RecentSessionsPanel"
      data-test-element="container"
      data-testid="recent-sessions-panel"
    >
      <div className={styles.panelHeader} data-test-element="header">
        <span className={styles.headerTitle} data-test-element="title">
          Recent
        </span>
        <span
          className="link dark-blue pointer f6"
          onClick={onViewAllSessions}
          role="link"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onViewAllSessions();
            }
          }}
          data-test-element="link"
          data-testid="view-all-sessions"
        >
          View all sessions
        </span>
      </div>
      <div className={styles.panelBody} data-test-element="body">
        <NoDataMessage title="No recent sessions" text="Agent sessions you run will appear here." dark />
      </div>
    </div>
  );
};

export default RecentSessionsPanel;
